import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { Grid } from '@mui/material';
import { useContext } from 'react';
import { SelectorGeneric } from '../common/DeviceGenerics';
import { DeviceLinkContext } from './DeviceLinkContext';
const UnlinkingDevices = (props) => {
    const { setUnlinkDevice } = props;
    const { prelinkedDevice, allowEntities, unlinkDevice } = useContext(DeviceLinkContext);
    return (_jsxs("div", { children: [_jsx("br", {}), _jsxs(Grid, { id: 'View-Relevant-Devices', container: true, direction: "row", size: { xs: 12 }, spacing: 1, sx: {
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }, children: [_jsx(Grid, { size: { xs: 3 }, children: _jsx(Typography, { variant: "body2", component: "p", color: "primary", children: `6) Replace Dev.` }) }), _jsx(Grid, { size: { xs: 7 }, sx: { flexGrow: 1 }, children: setUnlinkDevice && prelinkedDevice && (_jsx(SelectorGeneric, { disabled: prelinkedDevice.length === 0 || !allowEntities, description: 'Replaced Device', choices: prelinkedDevice, choice: unlinkDevice, choose: setUnlinkDevice, none: true, sort: true })) })] })] }));
};
export default UnlinkingDevices;
